module.exports = __webpack_public_path__ + "static/img/miles_pictgrid2_800x679.ce1b75f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/miles_pictgrid2_800x679.jpg
// module id = a25W
// module chunks = 0